import Market from '@/creditflowresearch/domain/Market/Market';
import Region from '@/creditflowresearch/domain/Region';
import Segment from '@/creditflowresearch/domain/Segment';
import { MarketName, MarketAbbreviations } from '@/creditflowresearch/domain/Market/types/MarketType';
import { CORPORATE_SEGMENTS } from '@/creditflowresearch/domain/Segment/constants';
import { EUROPEAN_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class EuropeanMarket extends Market {
  static readonly MARKET_ID: string = EUROPEAN_MARKET_ID;

  static readonly NAME: MarketName = MarketName.EUROPEAN_MARKET;

  static readonly ABBREVIATION: MarketAbbreviations = MarketAbbreviations.EUROPEAN_MARKET;

  isVisible(): boolean {
    return true;
  }

  isBeta(): boolean {
    return true;
  }

  getSegments(): Segment[] {
    return CORPORATE_SEGMENTS.map((type) => Segment.from(type)).filter(
      (segment): segment is Segment => segment !== null,
    );
  }

  protected getRegionIdForMarket(): string | null {
    return Region.EMEA_ID;
  }
}

export default EuropeanMarket;
